import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecaptchComponent } from '../recaptch/recaptch.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { TranslationModule } from 'src/app/i18n/translation.module';
import { ConfigService } from 'src/app/services/config.service';

@NgModule({
  declarations: [
    RecaptchComponent
  ],
  imports: [
    CommonModule,
    RecaptchaV3Module,
    CommonModule,
    TranslationModule
  ],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: (config: ConfigService) => config.recaptchaSiteKey,
      deps: [ConfigService]
    },
  ],
  exports: [RecaptchComponent]
})
export class RecaptchModule { }